import * as React from 'react';
import Utils from '../../../utils';
import { DownloadStatus } from './styles';

interface ListItemDownloadStatusProps {
	isUpToDate: boolean;
	isUpdatable: boolean;
	isRowView: boolean;
	isDownloading?: boolean;
}

const ListItemDownloadStatus = ({ isUpToDate, isUpdatable, isRowView, isDownloading }: ListItemDownloadStatusProps) => {

	return (
		<DownloadStatus isRowView={isRowView}>
			{getStatusElement(isUpToDate, isUpdatable, isDownloading ? isDownloading : false)}
		</DownloadStatus>
	);
};

const getStatusElement = (isUpToDate: boolean, isUpdatable: boolean, isDownloading: boolean) => {
	if ((!isUpToDate && !isUpdatable) || isDownloading) {
		return null;
	}

	return isUpToDate
		? Utils.getSvgIcon('iconset_check-circle')
		: Utils.getSvgIcon('iconset_refresh')
	;
};

export default ListItemDownloadStatus;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/DownloadStatus/index.tsx